module.exports = __webpack_public_path__ + "static/eddie-76b26ce9a964931b2690a5e7cfb54972.png";